import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

export default {
  getHeaders () {
    const user = JSON.parse(sessionStorage.getItem('user'))

    return {
      id: user ? user.login : '',
      'content-type': 'text/plain'
    }
  },

  async watchService (credentials) {
    return axios.post('/watch/watch', credentials, { headers: this.getHeaders(), withCredentials: true })
  }
}
